import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';

function applyVoucherFilters (id, status) {
    $('#vouchers-filter-form').submit()
}

function claimVoucher (id, url) {
    axios.post('/broker/employee/claim_voucher', {
        id
    }).then(function (resp) {
        if (resp.data.status) {
            url = url.toString()
            var input = document.createElement('input');
            input.setAttribute('value', url);
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            $("#error-modal").modal('show')
            let statusElement = document.getElementById('active-status-link-' + id)
            statusElement.classList.remove('archived-status')
            statusElement.classList.add('active-status')
            statusElement.innerHTML = "<span class=\"d-none\">Status </span>Claimed"
            document.getElementById('action-button-'+id).innerHTML = url
            document.getElementById('error-title').innerHTML = 'Voucher claimed'
            document.getElementById('error-body').innerHTML = 'Voucher claimed successfully and code is copied to your clipboard'
        } else {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'Error Occurred'
            document.getElementById('error-body').innerHTML = 'Unknown error occurred'
        }
    }).catch(function () {
        $("#error-modal").modal('show')
        document.getElementById('error-title').innerHTML = 'Error Occurred'
        document.getElementById('error-body').innerHTML = 'Unknown error occurred'
    })
}

function changeVoucherStatus (id, status) {
    axios.post('/broker/vouchers/status',{
        id,
        status
    }).then(function () {

    })
    let htmlStatus = status === 'V' ? 'Voided' : 'Expired'
    $('#active-status-link-'+id)
        .removeClass('active-status')
        .addClass('archived-status')
        .html(htmlStatus)
}

function property_type () {
  
    let contractor=document.getElementById('type-contractor');
    let manager=document.getElementById('type-property');
    if (contractor.checked)
    {
        let type_text=document.getElementById('type_text');
        type_text.innerHTML="Contractor";
    }
    if(manager.checked)
    {
        let type_text=document.getElementById('type_text');
        type_text.innerHTML="Property Manager";
    }
}

function showPurchaseVouchersModal() {
    $("#payment-method-update").modal("show");
}

jQuery(function() { 
    (function($) {
        $('#search-voucher').keyup(function() {
            var rex = new RegExp($(this).val(), 'i');
            $('#all-vouchers tr').hide();
            $('#all-vouchers tr').filter(function() {
                return rex.test($(this).text());
            }).show();
            $('.no-data').hide();
            if ($('#all-vouchers tr:visible').length == 0) {
                $('.no-data').show();
            }
        });
    }(window.jQuery));
});

// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const brokerVouchersModule = {
    applyVoucherFilters,
    claimVoucher,
    changeVoucherStatus,
    property_type,
    showPurchaseVouchersModal,
}
